<template>
  <div class="">
    <md-bar>如果没有账号会自动创建</md-bar>
    <div class="mb-10 mt-10 p-0-10">
      <md-field
        v-model="mobile"
        label="手机号"
        placeholder="手机号"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <md-field
        v-model="password"
        label="密码"
        placeholder="密码"
        type="text"
        class="mb-10 bd-radio-8"
      ></md-field>
      <!-- <md-button @click="accountLogin" class="mb-10">登录</md-button> -->
      <md-button @click="bindWeixinLogin" class="mb-10"
        >绑定微信并登录</md-button
      >
    </div>
  </div>
</template>

<script>
import { mcToast } from '@/utils/mcSdkUtils'
import API from '@/api'
import { ACCOUNT_BIND_TYPE } from '@/utils/constUtils'
import { getItem, setItem } from '@/utils/comUtils'

export default {
  name: 'PageWechatLoginAuth',
  data() {
    return {
      mobile: '',
      password: '',
      wechatUserInfo: getItem('weixinUserInfo')
    }
  },
  methods: {
    // 绑定微信并登录
    async bindWeixinLogin() {
      if (!this.mobile) {
        mcToast({
          msg: '请先输入手机号'
        })
        return
      }
      // 根据手机号查询账号信息
      const res = await API.getAccountSimpleness({
        bindType: ACCOUNT_BIND_TYPE.mobile,
        bindValue: this.mobile
      })
      console.log(`res--->`, res)
      // TODO
      if (res && res.result && res.result !== 'ME01010251002') {
        mcToast({
          msg: res.message
        })
        return false
      } else if ((res || {}).accountId) {
        // mcToast({
        //   msg: '该账号已存在，请直接绑定'
        // })
        this.wechatUserInfo.accountId = (res || {}).accountId
        setItem('weixinUserInfo', this.wechatUserInfo)
        // 授权绑定魔蓝账号
        const bind = await API.accountBind({
          bindValue: this.wechatUserInfo.unionid,
          bindType: ACCOUNT_BIND_TYPE.weixinUid,
          password: this.password,
          accountId: (res || {}).accountId
        })
        if (bind && bind.result && bind.result !== '0') {
          mcToast({
            msg: bind.message
          })
          return false
        }
        mcToast({
          msg: '微信绑定成功！'
        })
        console.log(`accountBind success-->`, bind)
        setTimeout(() => {
          this.$router.replace('/')
        }, 300)
      } else if (res.result === 'ME01010251002') {
        const register = await API.createAccountRegister({
          password: this.password,
          unionId: this.wechatUserInfo.unionid,
          mobile: this.mobile,
          registerType: ACCOUNT_BIND_TYPE.weixinUid,
          registerValue: this.wechatUserInfo.unionid,
          name: this.wechatUserInfo.nickname,
          needCodeFlag: false,
          bindValue: this.mobile,
          bindType: 4,
          checkCode: ''
        })
        if (register && register.result && register.result !== '0') {
          mcToast({
            msg: register.message
          })
          return false
        }
        this.wechatUserInfo.accountId = (register || {}).data
        setItem('weixinUserInfo', this.wechatUserInfo)
        console.log(`register success-->`, register)
        mcToast({
          msg: '登录成功'
        })
        setTimeout(() => {
          this.$router.replace('/')
        }, 300)
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
